// TODO: Migrate to V2
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'

import {
  REACTIVATE_USER_SUBSCRIPTION_KEY,
  reactivateUserSubscription,
} from '@/actions/settings/billingActions'
import { sendUserCancellationMessageZap } from '@/actions/zapierActions'
import { useAnalyticsTrack, useAnalyticsView } from '@/features/amplitude'
import { selectHeardProductSubscription } from '@/reducers/subscription.slice'
import { getCurrentUser } from '@/selectors/user.selectors'
import { DATE_FORMATS } from '@/utils/dateHelpers'
import { useReselector } from '@/utils/sharedHooks'
import { useAppDispatch } from '@/utils/typeHelpers'
import { Alert, Text, Button, Modal } from '@/componentsV1/BaseComponents'
import { selectErrorsForKeys } from '@/reducers/fetch'

export const ReactivatePlanModal = ({
  open,
  close,
  redirectUrl,
}: {
  open: boolean
  close: () => void
  redirectUrl?: string
}) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const subscription = useReselector(selectHeardProductSubscription)
  const [disabled, setDisabled] = useState(false)
  const track = useAnalyticsTrack()
  const pageView = useAnalyticsView()
  const currentUser = useReselector(getCurrentUser)

  const error = useReselector(selectErrorsForKeys, [
    REACTIVATE_USER_SUBSCRIPTION_KEY,
  ])

  useEffect(() => {
    pageView('reactivate plan modal')
  }, [pageView])

  const reactivatePlan = async () => {
    setDisabled(true)
    track('submit reactivate plan request')

    const result = await reactivateUserSubscription()(dispatch)
    setDisabled(false)
    if (!result) {
      return
    }

    sendUserCancellationMessageZap(
      currentUser,
      'reactivated_cancelling_account'
    )
    close()
    if (redirectUrl) {
      navigate(redirectUrl)
    } else {
      location.reload()
    }
  }

  return (
    <Modal
      size={'small'}
      dimmer={'inverted'}
      className="ReactivatePlanModal"
      open={open}
      onClose={close}
    >
      <Modal.Header>Reactive your Heard Plan</Modal.Header>
      <Modal.Content>
        {error.length > 0 && <Alert type="error">{error[0].message}</Alert>}
        <Text as="bodyLg">
          You have full access to Heard until your billing cycle ends on{' '}
          {subscription?.nextBillingDate &&
            moment
              .unix(subscription.nextBillingDate)
              .format(DATE_FORMATS.DISPLAY_LONG)}
          .
        </Text>
        <br />
        <Text as="bodyLg">
          Reactivating your Heard plan means that you will be charged on your
          next billing date.
        </Text>
      </Modal.Content>
      <Modal.Actions>
        <Button variant="secondary" onClick={close}>
          Close
        </Button>
        <Button variant="primary" onClick={reactivatePlan} disabled={disabled}>
          Reactivate Plan
        </Button>
      </Modal.Actions>
    </Modal>
  )
}
